import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import * as authRepository from '../repositories/authRepository';

export default function ForgotPasswordPage() {
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');
    const form = new FormData(e.currentTarget);
    try {
      const data = await authRepository.requestPasswordReset(form.get('email') as string);
      setMessage(data.message || 'Reset email sent');
      setIsError(false);
    } catch (err) {
      setMessage((err as Error).message || 'Failed to send reset email');
      setIsError(true);
    }
  };

  return (
    <AuthLayout
      title="Reset Password"
      subtitle="Enter your email and we'll send you a reset link."
      message={message}
      isError={isError}
      footer={<Link to="/login">Back to sign in</Link>}
    >
      <form onSubmit={handleSubmit} className="auth-form">
        <label>
          <span>Email</span>
          <input type="email" name="email" autoComplete="email" required />
        </label>
        <button type="submit" className="primary-button">Send reset link</button>
      </form>
    </AuthLayout>
  );
}
